import React, {useEffect, useRef, useState} from 'react';
import MessageList from './MessageList.js'; // Assuming this is an imported component
import {word} from '../../word.js'
import Api from '../../Api.js'
import {useParams} from "react-router-dom";
import {REACT_SOCKET_URL} from '../../config.js'

const MessageInput = ({ visibleMessage}) => {
    const {id} = useParams()
    const [message,setMessage] = useState([]);
    const [text, setText] = useState('');
    const [sendMessage, setSendMessage] = useState(false);
    const [file, setFile] = useState('');
    const [filePreviewUrl, setFilePreviewUrl] = useState('');
    const socketRef = useRef(null);
    useEffect(() => {
        // Load initial messages
        Api.getSurveyMessage(id).then(({ data }) => {
            setMessage(data);
        });

        // Setup WebSocket connection
        const token = localStorage.getItem('token'); // Or get your JWT token from auth

        socketRef.current = new WebSocket(`${REACT_SOCKET_URL}/ws/survey/${id}/?token=${token}`);

        socketRef.current.onmessage = async (e) => {
            const data = JSON.parse(e.data);
            console.log(data.type === "NEW_MESSAGE", data);

            if (data.type === "NEW_MESSAGE") {
                const {data} = await Api.getSurveyMessage(id)
                setMessage(data)
            }
        };

        socketRef.current.onopen = () => {
            console.log("WebSocket connected");
        };

        socketRef.current.onclose = () => {
            console.log("WebSocket disconnected");
        };

        return () => {
            if (socketRef.current) {
                socketRef.current.close();
            }
        };
    }, [id]);
    const handleTaskSms =async () => {
       try {
           if (text === '' && !file) return;
           const formData = new FormData();
           formData.append("text", text);
           formData.append("image", file);
           setSendMessage(true);
           await Api.postSurveyMessage(id,formData)
           const {data} = await Api.getSurveyMessage(id)
           setMessage(data);
           setSendMessage(false);
           setText('');
           setFile('');
       }catch (e) {
           setSendMessage(false);

       }

    };

    const keyPress = async (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (!sendMessage) {
                await handleTaskSms();
            }
        }
    };


    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
        if (selectedFile.size === 0) {
            alert("Ֆայլը դատարկ է");
            return;
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            setFile(selectedFile);
            setFilePreviewUrl(reader.result);
        };
        reader.readAsDataURL(selectedFile);
    };

    return (
        <div className="message-list-inputs" style={{width:window.innerWidth > 600 ? 600 : window.innerWidth}}>
            {visibleMessage && <MessageList setMessage={setMessage} message={message}/>}
            {visibleMessage && (
                <div className="send-message">
                    <div className='input-image'>
                        <div className="d-flex justify-content-end">{filePreviewUrl && <img style={{width:200}} src={filePreviewUrl} alt="Preview" />}</div>
                        <div className="send-file">
                            <textarea
                                className='area'
                                readOnly={sendMessage}
                                onKeyDown={keyPress}
                                name="text"
                                autoFocus
                                placeholder={word.enter_message}
                                value={text}
                                onChange={(e) => setText(e.target.value)}
                            />
                            <div className='message-icons'>
                                <label>
                                    <i className="fas fa-image"/>
                                    <input
                                        type="file"
                                        className='input-icon'
                                        onChange={handleFileChange}
                                    />
                                </label>
                                <i
                                    onClick={async () => {
                                        if (!sendMessage) await handleTaskSms();
                                    }}
                                    className="fa fa-paper-plane"
                                    aria-hidden="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MessageInput;
